const speedList: number[] = [0.5, 0.8, 1, 1.2, 1.5, 2];
speedList.forEach(item => {
    if (isNaN(item)) {
        console.error('参数发生NaN错误');
    }
});
export default speedList;
